exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".date-picker-placeholder {\n    width: 278px;\n}\n\n.inline-date-picker {\n    width: fit-content;\n}\n\n.logic-whens-wrapper .inline-date-picker.with-date-value {\n    width: 80px;\n}", ""]);
